var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderSignInViewMicrosoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3527_5214)",
    filter: "url(#filter0_dd_3527_5214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6709 11.3333C14.6709 11.3333 18.9086 8.54269 19 8.54868C18.6979 7.4132 18.0599 6.38669 17.1634 5.59389C16.2669 4.80108 15.1507 4.27614 13.9502 4.08284C12.7498 3.88954 11.517 4.03622 10.4015 4.50505C9.28597 4.97388 8.3359 5.74467 7.6667 6.72375H7.73084L14.6709 11.3333Z",
    fill: "white",
    stroke: "#3B6CD3",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7388 7.425C9.9381 6.92776 9.01471 6.6651 8.073 6.66669H8.00823C7.08669 6.67878 6.18582 6.94241 5.40233 7.4293C4.61884 7.91618 3.98231 8.60794 3.56107 9.43031C3.13983 10.2527 2.94978 11.1746 3.01133 12.0971C3.07288 13.0197 3.38369 13.908 3.91041 14.6667L10.7311 13.9394L15 9.98548L10.7388 7.425Z",
    fill: "white",
    stroke: "#3B6CD3",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2929 8.6767C19.2036 8.67024 19.114 8.6669 19.0245 8.66669C18.4823 8.6665 17.9459 8.78014 17.4484 9.00058L15 10.0547L17.8739 13.4661L22.5247 14.6667C22.8401 14.0672 23.0035 13.3964 23 12.7156C22.9965 12.0347 22.8261 11.3657 22.5046 10.7697C22.183 10.1737 21.7205 9.66978 21.1594 9.30412C20.5983 8.93846 19.9565 8.72274 19.2929 8.6767Z",
    fill: "white",
    stroke: "#3B6CD3",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7755 12.4518L17.7356 11.8393L15.351 10.4302L14.6233 10L12.7042 10.7972L9.02751 12.3227L7.3792 13.0059L3.66669 14.5465C4.12789 15.2012 4.74285 15.736 5.45902 16.1052C6.1752 16.4744 6.97131 16.667 7.77934 16.6667H18.7469C19.4822 16.6668 20.2039 16.4705 20.8354 16.0987C21.4668 15.7268 21.9844 15.1932 22.3334 14.5545L18.7755 12.4518Z",
    fill: "white",
    stroke: "#3B6CD3",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3527_5214",
    x: 0.106469,
    y: -1.44677,
    width: 25.7871,
    height: 25.7871,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.44677
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.44677
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.380392 0 0 0 0 0.380392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3527_5214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.723383
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.723383
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.380392 0 0 0 0 0.380392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_dropShadow_3527_5214",
    result: "effect2_dropShadow_3527_5214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3527_5214",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3527_5214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSignInViewMicrosoft);
export default __webpack_public_path__ + "static/media/HeaderSignInViewMicrosoft.39c0115e4af9fb2d1811b2afb221afcd.svg";
export { ForwardRef as ReactComponent };